import { Button } from '../../../../../../components/button/button';
import { Container } from '../../../../../../components/container/container';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { LangInput } from '../../../../../../features/lang-input/lang-input';
import { MultiSelect } from '../../../../../../features/multi-select/multi-select';
import { validateLang } from '../../../../../../helpers/lang';
import { validate } from '../../../../../../helpers/validate';
import s from './create-employee-modal.module.css';
import { useCreateEmployeeModal } from './use-create-employee-modal';

export const CreateEmployeeModal = (props: ModalProps) => {
  const {
    employee,
    handleChangeBranch,
    handleChangeSurname,
    handleChangeTags,
    postEmployee,
    handleChangeName,
    isLoading,
    setEmployee,
    branches,
    tags,
    selectedTags,
    selectedBranches,
    putEmployee,
    t,
  } = useCreateEmployeeModal();
  const isEdit = !!employee?.id;

  const handleSubmit = async () => {
    const isValid = validate({
      name: { rule: () => validateLang(employee?.name) },
      surname: { rule: () => validateLang(employee?.surname) },
      branch: { rule: () => !!employee?.places?.length },
    });
    if (!isValid) return;

    if (employee) {
      if (isEdit) {
        await putEmployee(employee);
      } else {
        await postEmployee(employee);
      }
      setEmployee({});
      props.onClose();
    }
  };

  return (
    <Modal
      {...props}
      className={s.feature}
      title={t(isEdit ? 'Изменить данные сотрудника' : 'Добавить сотрудника')}
      withLang
    >
      <Container label={t('Имя')} required>
        <LangInput
          value={employee?.name}
          onChange={handleChangeName}
          name="name"
          data-test-id="name-input"
        />
      </Container>

      <Container label={t('Фамилия')} required>
        <LangInput
          value={employee?.surname}
          onChange={handleChangeSurname}
          name="surname"
          data-test-id="surname-input"
        />
      </Container>

      <Container label={t('Филиал')} required>
        <MultiSelect
          options={branches}
          value={selectedBranches}
          onSelect={handleChangeBranch}
          name="branch"
          data-testid="branch-input"
        />
      </Container>

      <Container label={t('Должности')}>
        <MultiSelect
          onSelect={handleChangeTags}
          options={tags}
          value={selectedTags}
          data-testid="tags-input"
        />
      </Container>

      <div className={s.controls}>
        <Button
          onClick={props.onClose}
          disabled={isLoading}
          variant="secondary"
          data-testid="cancel-button"
        >
          {t('Отменить')}
        </Button>
        <Button onClick={handleSubmit} disabled={isLoading} data-testid="submit-button">
          {t(isEdit ? 'Изменить' : 'Добавить')}
        </Button>
      </div>
    </Modal>
  );
};
